import React from "react";

const ENTRIES = [
  {
    school: "Technical University of Košice",
    note: "Informatics",
    years: "2024 — current",
  },
  {
    school: "Gymnázium, Konštantínova 64, Stropkov",
    note: "",
    years: "2019 — 2024",
  },
];

// draft content — edit freely
const SKILL_GROUPS = [
  { group: "Languages", items: ["JavaScript", "Python", "HTML & CSS"] },
  {
    group: "Frameworks & tools",
    items: ["React", "Node", "React Native"],
  },
];

const LANGUAGES = [
  { lang: "Slovak", level: "Native" },
  { lang: "English", level: "Fluent" },
  { lang: "German", level: "Basic" }, // adjust/remove
];

export default function Education() {
  return (
    <section id="education" className="section education">
      <div className="education-inner">
        <h2>Education</h2>

        <div className="education-list">
          {ENTRIES.map((e) => (
            <div key={e.school} className="education-entry">
              <div>
                <p className="edu-school">{e.school}</p>
                {e.note && <p className="edu-note">{e.note}</p>}
              </div>
              <span className="edu-years">{e.years}</span>
            </div>
          ))}
        </div>

        <div className="edu-grid">
          <div className="edu-skills">
            <p className="edu-subhead">Technical skills</p>
            {SKILL_GROUPS.map((g) => (
              <div key={g.group} className="edu-skill-group">
                <p className="edu-group-label">{g.group}</p>
                <div className="edu-chips">
                  {g.items.map((item) => (
                    <span key={item} className="chip">
                      {item}
                    </span>
                  ))}
                </div>
              </div>
            ))}
          </div>

          <div className="edu-langs">
            <p className="edu-subhead">Languages</p>
            {LANGUAGES.map((l) => (
              <div key={l.lang} className="edu-lang-row">
                <p className="edu-lang">{l.lang}</p>
                <span className="edu-lang-level">{l.level}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
